import { defineComponent as _defineComponent } from 'vue';
import { GChart } from 'vue-google-charts';
import { editableFundReportAdditionalInfo } from '~/assets/fund/periodicReport';
import { renderMarkdown } from '~/functions/markdown';
import { FundStrategy } from '~/types/types';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'investmentsCategorizationChartData',
  props: {
    investmentsCategorizationChartData: {
      type: Array
    },
    article: {
      type: String,
      default: FundStrategy.Article_8
    }
  },
  setup: function setup(__props) {
    // TODO: this part is duplicated!!!

    var locale = computed(function () {
      return getLocale();
    });
    return {
      __sfc: true,
      locale: locale,
      GChart: GChart,
      editableFundReportAdditionalInfo: editableFundReportAdditionalInfo,
      renderMarkdown: renderMarkdown,
      FundStrategy: FundStrategy
    };
  }
});